/**
 * Préchargeur Biocemento — compteur 0–100 %, logo animé, révélation.
 */
(function () {
  const root = document.documentElement;
  const preloader = document.getElementById('bio-preloader');
  if (!preloader || root.classList.contains('bio-preloader-done')) return;

  const valueEl = preloader.querySelector('[data-bio-preloader-value]');
  const barEl = preloader.querySelector('[data-bio-preloader-bar]');
  const lettersHost = preloader.querySelector('[data-bio-preloader-letters]');
  const logoStage = preloader.querySelector('[data-bio-preloader-logo]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const LOGO_TEXT = 'BIOCEMENTO';
  const LOGO_HOLD_MS = reducedMotion ? 280 : 1100;
  const LOGO_ANIM_MS = reducedMotion ? 120 : 950;

  let displayed = 0;
  let target = 0;
  let rafId = 0;
  let loadFinished = false;
  let exitStarted = false;
  const startedAt = performance.now();
  const MIN_COUNTER_MS = reducedMotion ? 200 : 1400;
  const FORCE_AT = reducedMotion ? 400 : 9000;

  function buildLogoLetters() {
    if (!lettersHost || lettersHost.childElementCount) return;
    LOGO_TEXT.split('').forEach((char, i) => {
      const span = document.createElement('span');
      span.className = 'bio-preloader__logo-letter';
      span.style.setProperty('--bio-letter-i', String(i));
      span.textContent = char;
      lettersHost.appendChild(span);
    });
    const mark = document.createElement('span');
    mark.className = 'bio-preloader__logo-mark';
    mark.textContent = '®';
    mark.setAttribute('aria-hidden', 'true');
    lettersHost.appendChild(mark);
  }

  buildLogoLetters();

  function setTarget(n) {
    target = Math.min(100, Math.max(target, n));
  }

  function render() {
    if (valueEl) valueEl.textContent = String(Math.round(displayed));
    if (barEl) barEl.style.width = `${displayed}%`;
  }

  function tick() {
    const delta = target - displayed;
    if (Math.abs(delta) < 0.4) {
      displayed = target;
    } else {
      const step = Math.max(1, delta * (displayed > 85 ? 0.22 : 0.14));
      displayed = Math.min(target, displayed + step);
    }
    render();

    if (!loadFinished || displayed < 100) {
      rafId = requestAnimationFrame(tick);
    }
  }

  function onLoadComplete() {
    if (loadFinished) return;
    loadFinished = true;
    setTarget(100);

    const elapsed = performance.now() - startedAt;
    const wait = Math.max(0, MIN_COUNTER_MS - elapsed);
    window.setTimeout(showLogo, wait);
  }

  function showLogo() {
    if (exitStarted) return;
    cancelAnimationFrame(rafId);
    displayed = 100;
    target = 100;
    render();

    if (logoStage) {
      logoStage.removeAttribute('aria-hidden');
    }

    preloader.classList.add('is-logo');

    window.requestAnimationFrame(() => {
      preloader.classList.add('is-logo-animate');
      window.setTimeout(exit, LOGO_ANIM_MS + LOGO_HOLD_MS);
    });
  }

  function exit() {
    if (exitStarted) return;
    exitStarted = true;

    preloader.classList.add('is-exiting');
    preloader.setAttribute('aria-busy', 'false');
    preloader.setAttribute('aria-hidden', 'true');

    const onEnd = () => {
      preloader.classList.add('is-done');
      root.classList.remove('bio-preloader-active');
      root.classList.add('bio-preloader-done');
      preloader.removeEventListener('transitionend', onEnd);
      document.dispatchEvent(new CustomEvent('bio:preloader:done', { bubbles: true }));
    };

    if (reducedMotion) {
      onEnd();
      return;
    }

    preloader.addEventListener('transitionend', onEnd);
    window.setTimeout(onEnd, 1200);
  }

  function trackHeroMedia() {
    const video = document.getElementById('heroVideo');
    if (!video) return;
    const onReady = () => setTarget(92);
    if (video.readyState >= 3) {
      onReady();
      return;
    }
    video.addEventListener('canplaythrough', onReady, { once: true });
    video.addEventListener('loadeddata', () => setTarget(80), { once: true });
  }

  function trackImages() {
    trackHeroMedia();
    const imgs = Array.from(document.images || []);
    if (!imgs.length) {
      setTarget(72);
      return;
    }

    let pending = 0;
    const bump = () => {
      pending = Math.max(0, pending - 1);
      const ratio = 1 - pending / imgs.length;
      setTarget(28 + ratio * 52);
      if (pending === 0) setTarget(78);
    };

    imgs.forEach((img) => {
      if (img.complete && img.naturalWidth > 0) return;
      pending += 1;
      const done = () => {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        bump();
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });

    if (pending === 0) setTarget(72);
  }

  setTarget(8);
  rafId = requestAnimationFrame(tick);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        setTarget(32);
        trackImages();
      },
      { once: true }
    );
  } else {
    setTarget(32);
    trackImages();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => setTarget(88)).catch(() => setTarget(88));
  } else {
    window.setTimeout(() => setTarget(85), 400);
  }

  if (document.readyState === 'complete') {
    setTarget(96);
    onLoadComplete();
  } else {
    window.addEventListener(
      'load',
      () => {
        setTarget(96);
        onLoadComplete();
      },
      { once: true }
    );
  }

  window.setTimeout(() => {
    setTarget(94);
    onLoadComplete();
  }, FORCE_AT);

  if (reducedMotion) {
    window.setTimeout(onLoadComplete, 350);
  }

  if (window.Shopify && window.Shopify.designMode) {
    root.classList.remove('bio-preloader-active');
    root.classList.add('bio-preloader-done');
    preloader.remove();
  }
})();
